module.exports = __webpack_public_path__ + "sansg/img/ban.2e13352c.png";